import { useRef } from "react";
import { useParallax } from "@/components/landing/Reveal";

const MAX_SHIFT = 120;
const shift = (y) => `translate3d(0, ${Math.min(Math.max(y, 0) * 0.22, MAX_SHIFT)}px, 0) scale(1.08)`;

// Static masked wrapper: the moving image can never show an edge near the hero bottom.
export const HeroBackdrop = () => {
  const ref = useRef(null);
  useParallax(ref, shift);
  return (
    <>
      <div data-testid="hero-backdrop"
        className="pointer-events-none absolute inset-0 overflow-hidden [mask-image:linear-gradient(to_bottom,black_50%,transparent_86%)]">
        <img ref={ref} src="/images/aurora.webp" alt="Teal and violet aurora light over a dark sky, the backdrop of the AetherTags Etsy SEO tool" decoding="async" width="1264" height="848"
          className="absolute inset-x-0 top-0 h-full w-full object-cover opacity-90" style={{ transform: shift(0) }} />
        <div className="aurora-layer opacity-70" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_65%_at_50%_35%,rgba(7,8,15,0.35),#07080F_92%)]" />
      </div>
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-48 bg-gradient-to-b from-transparent to-[#07080F]" />
    </>
  );
};
